<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-08-20 09:50:28
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:07:17
 -->
<!--  -->
<template>
  <div class="concatPublicTheme">
    <el-dialog width="75%" top="5vh" v-dialogDrag :append-to-body="true" :visible.sync="isShow.show">
        <easyCrud  ref="dataTable"
        @mainTableReload="mainTableReload"
        :tableInfo='conf.mainTable'>
        <template slot-scope="row" slot="operation">
            <el-switch @change="changeAuth(row.row)"  v-model="row.row.__auth_status__" ></el-switch>
        </template>
    </easyCrud>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const mainTable = {
      buttonSetting: {
        allowAdd: false, allowEdit: false, allowDelete: false, allowView: false
      },
      header: { title: '资源关联公有主题 -- 公有主题列表' },
      table: {
        loading: false,
        height: 510,
        stripe: true,
        columns: [{
          prop: 'subjectName',
          label: '名称',
          type: 'input',
          isSearchCondition: true
        }, {
          prop: 'unifiedId',
          label: '统一ID',
          isSearchCondition: true,
          type: 'input'
        }, {
          prop: 'subjectType',
          label: '类型',
          isTag: true,
          type: 'select',
          isSearchCondition: true,
          tagFilter: function(columnData) {
            if (columnData === 'ORG') {
              return { data: '机构' }
            } else if (columnData === 'ROLE') {
              return { data: '角色' }
            } else if (columnData === 'USER') {
              return { data: '用户' }
            } else {
              return { data: '其他' }
            }
          },
          dicData: [{
            'label': '机构',
            'value': 'ORG'
          }, {
            'label': '角色',
            'value': 'ROLE'
          }, {
            'label': '用户',
            'value': 'USER'
          }, {
            'label': '其他',
            'value': 'OTHER'
          }]
        }, {
          prop: 'subjectStatus',
          label: '状态',
          isTag: true,
          type: 'select',
          isSearchCondition: true,
          tagFilter: function(columnData) {
            if (columnData === 1) {
              return { data: '可用', type: 'success' }
            } else {
              return { data: '不可用', type: 'warning' }
            }
          },
          dicData: [{
            'label': '可用',
            'value': 1
          }, {
            'label': '不可用',
            'value': 2
          }]
        }, {
          prop: 'unionResourceType',
          label: '关联状态',
          isSearchCondition: true,
          showInTable: false,
          dicData: [{ 'label': '已关联', 'value': 'IN' }, { 'label': '未关联', 'value': 'NOT_IN' }],
          type: 'select'
        }],
        operation: {
          width: 220,
          slotName: 'operation'
        },
        tableData: [],
        paging: {
          currentPage: 1,
          pageSizes: [10, 15, 20, 25],
          pageSize: 10,
          total: 0
        },
        reload: 'mainTableReload',
        reloadConditions: {},
        addDefultValue: {}
      }
    }
    return {
      conf: { mainTable }
    }
  },
  props: ['isShow', 'optionRow'],

  components: { },
  mounted: function(params) {

  },
  methods: {
    /** 主表重载函数 */
    mainTableReload: function(params) {
      this.conf.mainTable.table.loading = true
      this.$http.post('/permission/subject/public/query', {
        'entity': {
          unifiedId: params.unifiedId,
          subjectType: params.subjectType,
          subjectStatus: params.subjectStatus,
          subjectName: params.subjectName
        }
      }, { params: {
        pageNum: params.pageNum || 1,
        pageSize: params.pageSize || 10,
        'unionResourceType': params.unionResourceType,
        resourceIdList: this.optionRow.id
      }}).then(
        response => {
          for (let index = 0; index < response.data.records.length; index++) {
            let policySubjectList = response.data.records[index].policySubjectList
            if (params.unionResourceType === 'IN') {
              response.data.records[index].__auth_status__ = true
            } else if (params.unionResourceType === 'NOT_IN') {
              response.data.records[index].__auth_status__ = false
            } else {
              if (policySubjectList && policySubjectList.length >= 1) {
                response.data.records[index].__auth_status__ = true
              } else {
                response.data.records[index].__auth_status__ = false
              }
            }
          }
          this.conf.mainTable.table.tableData = response.data.records
          this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
          this.conf.mainTable.table.loading = false
        }
      ).catch(
        error => {
          this.conf.mainTable.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    changeAuth: function(row) {
      this.conf.mainTable.table.loading = true
      let postUrl = row.__auth_status__ ? '/permission/subject/subject/policy' : '/permission/subject/subject/policy/del'
      this.$http.post(postUrl, null, { params: {
        'appKey': this.optionRow.appKey,
        'resourceId': this.optionRow.id,
        subjectId: row.id
      }}).then(response => {
        this.conf.mainTable.table.loading = false
        this.$message.success('操作成功')
      }).catch(error => {
        this.conf.mainTable.table.loading = false
        this.$message.error(error.msg)
        row.__auth_status__ = !row.__auth_status__
      })
    //
    },
    /** 初始化表格 */
    Initialize: function(params) {
      this.conf.mainTable.table.tableData = []
      this.conf.mainTable.table.paging.total = 0
      this.conf.mainTable.table.paging.currentPage = 1
      this.$nextTick(() => this.mainTableReload({}))
      this.conf.mainTable.table.reloadConditions = {}
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
